export default __webpack_public_path__ + "static/media/dashboardlogo.f1f692e9.png";